export default __webpack_public_path__ + "static/media/notebook-download-icon.557db8d9.svg";